import { render, staticRenderFns } from "./QuaternaryDraggableQuestion.vue?vue&type=template&id=315bc25b&"
import script from "./QuaternaryDraggableQuestion.vue?vue&type=script&lang=js&"
export * from "./QuaternaryDraggableQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports